import { useMutation } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useProcessorSimples() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({
      cnpj,
      id_apuracao,
      xml,
      pgdas
    }: {
      cnpj?: string
      id_apuracao?: string
      xml: File
      pgdas: File
    }) => {
      if (!token) throw new Error('Token está ausente')
      if (!xml || !pgdas) throw new Error('Fotos são obrigatórias.')
      const formData = new FormData()
      formData.append('xml', xml)
      formData.append('pgdas', pgdas)
      if (cnpj) formData.append('cnpj', cnpj)
      if (id_apuracao) formData.append('id_apuracao', id_apuracao)

      const response = await api.post('microservices/xml/simples-nacional', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.data) throw new Error('Erro ao criar assinatura')
      return response.data
    }
  })
}
